<template>
  <div id="transactions">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>All User Transactions</h1>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="transactions"
            :search="search"
            :items-per-page="20"
          >
            <template v-slot:item.created_at="{ item }">
              <h4>{{ item.created_at | moment('timezone', timezone, " h:mm:ss a") }}</h4>
              {{ item.created_at | moment('timezone', timezone, " Do MMMM YYYY") }}
            </template>
            <template
              v-slot:item.name="{ item }"
            >{{ item.user.firstname + ' ' + item.user.lastname }}</template>
            <template v-slot:item.amount="{ item }">${{ (item.amount/100).toFixed(2) }}</template>
            <template v-slot:item.balance="{ item }">${{ (item.balance/100).toFixed(2) }}</template>
          </v-data-table>
        </v-card>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Transactions",
  data() {
    return {
      search: "",
      transactions: [],
      headers: [
        { text: "Date", value: "created_at", align: "start" },
        { text: "Name", value: "name" },
        { text: "Email", value: "user.email" },
        { text: "Amount", value: "amount" },
        { text: "Reference", value: "reference" },
        { text: "Type", value: "type" },
        { text: "Balance", value: "balance" },
        { text: "Category", value: "category" },
        { text: "Description", value: "description" }
      ]
    };
  },
  mounted() {
    this.getTransactions();
    this.getTimezone();
  },
  computed: {},
  methods: {
    getTransactions() {
      if (this.transactions == "undefined" || this.transactions.length < 1) {
        this.$store.dispatch("retrieveAdminTransactions").then(() => {
          this.transactions = this.$store.getters.adminTransactions;
        });
      }
    },
    getTimezone() {
      this.timezone = this.$moment.tz.guess();
    }
  }
};
</script>

<style scoped>
.container.fill-height > .row {
  max-width: initial;
}
</style>